/**
 * Класс для управления динамическим полем select в приложении
 * @package DynamicFieldClass
 * @version 1.0
 * @author BOLOTOV I.P.
 * @since 17.08.2022
 * @copyright (c) Internet-Frigate {@link http://www.ifrigate.ru}
 */
import { Inject, Injectable, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InterfaceAppServiceRegister } from '@app/app.interface';
import { mbHasMatch } from '@fui/fui-helpers';
import { FuiDestroyService } from '@services/destroy.service';
import { takeUntil } from 'rxjs/operators';
import { ISelect } from '../interfaces/Select.interface';
import { Select } from './Select.class';
import { SelectServiceLib } from './SelectServiceLib.service';

@Injectable()
/** Класс для управления динамическим полем select */
export abstract class SelectSearch extends Select implements ISelect, OnInit {
    /** Constructor */
    protected constructor(
        @Inject(FuiDestroyService) protected _destroy$: FuiDestroyService,
        service: SelectServiceLib,
    ) {
        super(_destroy$, service);
    }

    /** Элемент фильтра (строка фильтра) */
    filterCtrl: FormControl = new FormControl();

    ngOnInit() {
        this.setOptions(this.service.field.options as InterfaceAppServiceRegister[]);
        this.filterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
            if (this.service.options && this.service.options.length > 0) {
                this.filterSelect();
            }
        });
        setTimeout(() => {
            this.matSelect._overlayPanelClass += 'custom-select-panel';
        });
    }

    /** Фильтр для поиска в селекте */
    private filterSelect(): void {
        // Получение значения строки поиска.
        const searchStr = this.filterCtrl.value;
        if (!searchStr) {
            this.filteredSelect.next(this.service.options.slice());
            return;
        }
        // Организация фильтрованного массива
        this.filteredSelect.next(this.service.options.filter((value) => mbHasMatch(value.name, searchStr)));
    }

    /**
     * Установка опций select
     * @param options - набор опций
     */
    setOptions(options: InterfaceAppServiceRegister[]): void {
        this.service.options = [];
        this.service.fieldValue = {};
        const fieldValue = String(this.service.group?.get(this.service.field.name)?.value);
        options.forEach((value) => {
            const isDel = value?.is_del;

            if (typeof isDel === 'undefined' || (typeof isDel !== 'undefined' && (!isDel || isDel == '0'))) {
                this.service.options.push(value);
            } else if (
                typeof isDel !== 'undefined' &&
                (isDel === true || isDel == '1') &&
                (fieldValue == value.id || fieldValue.indexOf(String(value.id)) !== -1)
            ) {
                this.service.options.push(value);
                this.service.fieldValue[value.id] = value;
            }
        });
        this.filteredSelect.next(this.service.options.slice());
    }
}
